module.exports = __webpack_public_path__ + "img/quantity.dd53db0d.svg";